import { createFileRoute } from '@tanstack/react-router';
import { RewardsCardPage } from '@/features/loyalty';

export const Route = createFileRoute('/_auth/$orgId/marketing/rewards-card')({
  component: RewardsCardRoute,
});

function RewardsCardRoute() {
  const { orgId } = Route.useParams();
  return <RewardsCardPage routeOrgId={orgId} />;
}
